import { Link } from "react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { proxyUrl } from "@/lib/proxyUrl";
import type { CatalogType } from "@/types/catalog";
import type { Meta } from "@/lib/stremio";

interface CatalogGridProps {
  items?: Meta[];
  type: CatalogType;
}

export function CatalogGrid({ items = [], type }: CatalogGridProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6 stretch">
      {items.map((meta) => (
        <Link
          key={meta.id}
          to={`/${type === "series" ? "series" : "movies"}/${meta.id}`}
          className="block h-full"
        >
          <Card className="overflow-hidden transition-all hover:scale-[1.02] hover:shadow-lg h-full flex flex-col">
            <div className="aspect-[2/3] relative">
              {meta.poster && (
                <img
                  src={proxyUrl(meta.poster)}
                  alt={meta.name}
                  className="object-cover w-full h-full"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              )}
              {meta.logo && (
                <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/80 to-transparent flex items-end p-4">
                  <img
                    src={proxyUrl(meta.logo)}
                    alt={`${meta.name} logo`}
                    className="max-h-12 w-auto"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>
              )}
            </div>
            <CardHeader className="flex-grow">
              <CardTitle className="min-h-[2em]">{meta.name}</CardTitle>
              <CardDescription>
                {meta.year}
                {meta.runtime && ` • ${meta.runtime}`}
              </CardDescription>
            </CardHeader>
          </Card>
        </Link>
      ))}
    </div>
  );
}
